// extracted by mini-css-extract-plugin
export default {"cls1":"MultiPaperNewsStory-cls1_dKN","cls2":"MultiPaperNewsStory-cls2_s8Z MultiPaperNewsStory-cls1_dKN"};